import { call, put, StrictEffect, takeEvery } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";
import {
  ClientTransactions,
  ExtractionSummary
} from "@/jenesys-types/jenesys-entities/config";

import { performDataAction } from "@/services/api";

import {
  companyDashboardFailure,
  companyDashboardSuccess,
  companyTotalDashboardFailure,
  companyTotalDashboardSuccess,
  companyTransactionsFailure,
  companyTransactionsSuccess,
  loadCompanyDashboard,
  LoadCompanyDashboardAction,
  loadCompanyTotalDashboard,
  loadCompanyTransactions
} from "./companyDashboard";

export function* loadCompanyDashboardSaga(
  action: LoadCompanyDashboardAction
): Generator<StrictEffect, void, any> {
  const { companyId, dateRange } = action.payload;
  try {
    const companyDashboardResponse: ExtractionSummary = yield call(
      performDataAction,
      DataType.Summary,
      "getSummaryInRange",
      {
        clientId: companyId,
        before: dateRange.before,
        after: dateRange.after
      }
    );
    yield put(companyDashboardSuccess(companyDashboardResponse));
  } catch (error) {
    yield put(companyDashboardFailure(extractError(error)));
  }
}

export function* loadCompanyTotalDashboardSaga(
  action: LoadCompanyDashboardAction
): Generator<StrictEffect, void, any> {
  const { companyId } = action.payload;
  try {
    const companyDashboardResponse: ExtractionSummary = yield call(
      performDataAction,
      DataType.Summary,
      "list",
      {
        clientId: companyId
      }
    );
    yield put(companyTotalDashboardSuccess(companyDashboardResponse));
  } catch (error) {
    yield put(companyTotalDashboardFailure(extractError(error)));
  }
}

export function* loadCompanyTransactionsSaga(
  action: LoadCompanyDashboardAction
): Generator<StrictEffect, void, any> {
  const { companyId, dateRange, offset } = action.payload;
  try {
    const companyTransactionsResponse: ClientTransactions = yield call(
      performDataAction,
      DataType.Transactions,
      "getCompanyTransactions",
      {
        company_id: companyId,
        order_by: "finished_at:desc",
        before: dateRange.before,
        after: dateRange.after,
        offset
      }
    );
    yield put(companyTransactionsSuccess(companyTransactionsResponse));
  } catch (error) {
    yield put(companyTransactionsFailure(extractError(error)));
  }
}

export default function* CompanyDashboardSaga() {
  yield takeEvery(loadCompanyDashboard.type, loadCompanyDashboardSaga);
  yield takeEvery(
    loadCompanyTotalDashboard.type,
    loadCompanyTotalDashboardSaga
  );
  yield takeEvery(loadCompanyTransactions.type, loadCompanyTransactionsSaga);
}
